import { createLogger } from 'vue-logger-plugin';
import { useApiStore } from '@/modules/api/store/apiStore'
import type { LogEvent, LoggerHook } from 'vue-logger-plugin';
import { LogLevel } from '@/types/LogLevel'
import type { ILogPayload } from '@/types/ILogPayload.ts'


const levelMap: Record<string, LogLevel> = {
  debug: LogLevel.Debug,
  info: LogLevel.Info,
  warn: LogLevel.Warning,
  error: LogLevel.Error,
}

let isSendingLog = false

/**
 * Отправляет логи на бекенд по gRPC (ручка logEvent)
 */
const sendToBackendHook: LoggerHook = {
  // FIX: делаем async и защищаемся от повторного входа
  async run(event: LogEvent) {
    if (isSendingLog) return

    try {
      isSendingLog = true

      const apiStore = useApiStore()

      let userIdPrefix = ''
      try {
        const { useUserStore } = await import('@/modules/user/stores/userStore')
        const userStore = useUserStore()
        if (userStore && userStore.user && userStore.user.id) {
          userIdPrefix = `[User: ${userStore.user.id}] `
        }
      } catch {
        // Игнорируем
      }

      const messageParts = event.argumentArray.map((arg) => {
        if (arg === null) return 'null'
        if (arg === undefined) return 'undefined'
        if (arg instanceof Error) return arg.stack || arg.message
        if (typeof arg === 'object') {
          try {
            return JSON.stringify(arg)
          } catch {
            return String(arg)
          }
        }
        return String(arg)
      })

      const payload: ILogPayload = {
        level: levelMap[event.level],
        message: userIdPrefix + messageParts.join(' '),
      }

      // Важно await — иначе finally может сработать раньше исключения
      await apiStore.sendLogToBackend(payload)
    } catch {
      // Глушим любые ошибки — не триггерим новые логи из внутри хука
    } finally {
      isSendingLog = false
    }
  },
}



/**
 * Глобальный логгер приложения
 */
const EventLogger = createLogger({
  enabled: true,
  consoleEnabled: true,
  level: 'debug',
  callerInfo: true,
  prefixFormat: () => '[APP]',
  afterHooks: [sendToBackendHook],
});

export { EventLogger };
